module.exports = __webpack_public_path__ + "img/popup.753b0ef8.png";